import styled from 'styled-components'

import useReduxSelector from 'hooks/useReduxSelector'

import Logo from '../../../components/icons/BrandIconPositive'
import SearchBar from '../SearchBar'
import { InverseOption } from '../types'
import { useIncompleteBooking } from '../IncompleteBooking'

import Menu from './Menu'
import { LoggedInLinks, LoggedOutLinks, LinksLoadingSkeleton } from './NavLinks'

const LogoWrapper = styled.div<InverseOption>`
  display: flex;
  width: 36px;
  max-height: 50px; /* gets too tall on ios safari, causing the outer <a> tag to overlap other UI elements */
  margin-right: 16px;

  svg {
    flex-shrink: 0;
    color: ${({ inverse, theme }) =>
      inverse ? theme['-ds-neutral-100'].value : theme['-ds-core-300'].value};
    width: 36px;
    margin-right: 16px;
  }
`

const MobileSearchWrapper = styled.div`
  width: 100%;
  height: 40px;
`

const MenuTriggerWrapper = styled.div<InverseOption>`
  width: 36px;
  margin-left: 16px;
`

const Bar = styled.div<InverseOption>`
  height: 100%;
  width: 100%;
  background-color: transparent;
  padding: 16px;

  display: flex;
  align-items: center;
  position: relative;

  ${LogoWrapper}, ${MenuTriggerWrapper} {
    flex-shrink: 0;
  }

  ${MobileSearchWrapper} {
    flex-grow: 1;
  }
`

const Mobile = ({ inverse }: InverseOption) => {
  const isSignedIn = useReduxSelector((state) => state?.auth?.isSignedIn)

  const loading = useReduxSelector((state) => state?.auth?.loading)
  const updating = useReduxSelector((state) => state?.auth?.updating)

  const { showAlert: showIncompleteBooking } = useIncompleteBooking()

  const showLoggedIn = !loading && !updating && isSignedIn === true
  const showLoggedOut = !loading && !updating && isSignedIn === false

  return (
    <Bar inverse={inverse}>
      <a href="/" aria-label="Home page">
        <LogoWrapper inverse={inverse}>
          <Logo />
        </LogoWrapper>
      </a>
      <MobileSearchWrapper>
        <SearchBar mobile />
      </MobileSearchWrapper>
      <MenuTriggerWrapper inverse={inverse}>
        <Menu inverse={inverse} hasIncompleteBooking={showIncompleteBooking}>
          {isSignedIn == null && <LinksLoadingSkeleton />}
          {showLoggedIn && <LoggedInLinks />}
          {showLoggedOut && <LoggedOutLinks />}
        </Menu>
      </MenuTriggerWrapper>
    </Bar>
  )
}

export default Mobile
